import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectImplantTreatmentTable(state),
        type: 'implant-treatment',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryImplantTreatment,
    changeFilter: action.changeFilterImplantTreatment,
    toggleSort: action.toggleSortImplantTreatment,
    toggleMultiSort: action.toggleMultiSortImplantTreatment,
    gotoPage: action.gotoPageImplantTreatment,
    initialColumnsVisibility: action.initialTableSettingsImplantTreatment,
    toggleColumnVisibility: action.toggleColumnVisibilityImplantTreatment,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/ImplantTreatmentSalesOrderSearchContainer.js